const getters = {
  menuLeft: (state) => {
    return state.user.menuLeft
  },
  supplier_type_list: (state) => state.user.supplier_type_list,
  relationMenu: (state) => {
    return state.user.relationMenu;
  },
  userInfo: (state) => state.user.userInfo,
  shopInfo: (state) => state.user.shopInfo,
  goodsTypeList: (state) => state.goods.goodsTypeList,
  is_supplier: (state) => state.user.is_supplier,
  store_type: (state) => state.user.store_type,
  skip_type: (state) => state.user.skip_type,
};
export default getters;
